import React, { useState, useEffect } from "react";
import "./roomcencal.css";
import { token } from "../env"; // Make sure this path is correct

const NoticeCard = () => {
  const [result, setResult] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [error, setError] = useState(null);



  return (
    <div className="notice-card-container mb-3">
      <div className="notice-card">
        <div className="notice-card-body">
          <h5 className="notice-title">Cancellation Policy Jai Club</h5>
          <p className="notice-location">Mahaveer Marg, C-Scheme, Jaipur</p>
          <hr />

          <p className="notice-text">
            As per decision taken by the executive committee in its meeting held on 24.02.2019.
          </p>
          <p className="notice-text">
            CHARGES FOR CANCELLATION OF LAWN BOOKING
          </p>
          <ul className="cancellation-policy">
            <li><strong>10%</strong> WITHIN 6 MONTHS OF FUNCTION DATE</li>
            <li><strong>25%</strong> WITHIN 3 MONTHS OF FUNCTION DATE</li>
            <li><strong>50%</strong> WITHIN 1 MONTHS OF FUNCTION DATE</li>
            <li><strong>60%</strong> WITHIN 15 DAYS OF FUNCTION DATE</li>
            <li><strong>100%</strong> WITHIN 3 DAYS OF FUNCTION DATE</li>
          </ul>
          <hr />

 
          <p className="notice-position">Hon. Secretary</p>
        </div>
      </div>
    </div>
  );
};

export default NoticeCard;
